import * as React from "react";

export type LinkComponent = React.ComponentType<{
  to: string;
  children: React.ReactNode;
  className?: string;
  /**
   * Click handler. Callers sometimes need to `stopPropagation` on a
   * link embedded inside a larger clickable row (e.g., DataTable
   * cells nested in a row-level click handler), and both TanStack
   * Router's `<Link>` and plain `<a>` accept an `onClick` so the
   * wrapper type accepts it too.
   */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  /**
   * Search-params override forwarded to router links that support it
   * (TanStack `<Link>`). TanStack preserves the CURRENT query string when
   * `search` is omitted, so links leaving a filtered list pass `search={{}}`
   * to keep filter params off the destination URL.
   */
  search?: Record<string, unknown>;
  /** Disclosure state for links that toggle an inline panel (`ResourceList` rows). */
  "aria-expanded"?: boolean;
  "aria-controls"?: string;
}>;

export const LinkContext = React.createContext<LinkComponent | null>(null);

/**
 * Returns the router-aware link component provided via `<LinkProvider>`, or
 * `null` if none has been configured.
 */
export function useLinkComponent(): LinkComponent | null {
  return React.useContext(LinkContext);
}
